import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Input from "../../../components/Input/Input";
import Button from "../../../components/Buttons/Button";
import Label from "../../../components/Label";
import { Select } from "antd";
import { showNotification } from "../../../util/Utility";
import styled from "styled-components";
import { callApiV2 } from "../../../util/apiCaller";
import isEmail from "validator/lib/isEmail";
import ErrorMessage from "../../../components/ErrorMessage";
import DefaultModal from "../../../components/DefaultModal/DefaultModal";
import Box from "../../../components/Box";
import Icon from "../../../components/Icon/Icon";
import Dropdown from "../../../components/Dropdown";
import { useTranslation } from "react-i18next";
import { STORE_CITIES } from "../../Admin/adminActionType";
import { getPaymentMethodOption } from "../../../util/Utility";
import CitySelectUser from "../../../components/CustomDropdown/CitySelectUser";
import { Spinner } from "react-bootstrap";
import { useLocation, useSearchParams } from "react-router-dom";
import { apiURL } from "../../../app.config";
import { toast } from "react-toastify";
import { UPDATE_APPROVAL_STATUS } from "../../appActionType";
import { memberApprove, memberDecline } from "../../appAction";

const countryAbbr={
  '+31':'NL',
  "+49":"DE",
    "+43":"AT",
    "+33":"FR",
    "+32":"BE"
}

const paymentMethodOption = [
  {
    label: "Automatische incasso",
    value: "automatic",
  },
  {
    label: "Gratis abonnement",
    value: null,
  },
];

const customCountries = [
  { label: "Netherlands", value: "Netherlands" },
  { label: "Germany", value: "Germany" },
  { label: "France", value: "France" },
  { label: "Austria", value: "Austria" },
  { label: "Belgium", value: "Belgium" },
]

const DatePickerBox = styled.div`
  .ant-picker {
    width: 100%;
    height: 54px;
    border: 1px solid #eff0f7;
    box-shadow: 0px 2px 6px #13124212;
    border-radius: 8px;
  }
  .ant-picker-focused {
    border: 1px solid #eff0f7;
    box-shadow: 0px 2px 6px #13124212;
    border-radius: 8px;
  }

  .ant-picker .ant-picker-input > input::placeholder {
    /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: #1a1a1a;
  }
`;
const options = getPaymentMethodOption();

const AddForm = ({ details = null, memberSubId = null, approvalId = null }) => {
  const dispatch = useDispatch();
  const countries = useSelector((state) => state.adminReducer.countries);
  const cities = useSelector((state) => state.adminReducer.cities);
  const [isNext, setIsNext] = useState(false);
  const [isAddedNew, setIsAddedNew] = useState(false);
  const [isApprove, setIsApprove] = useState(false);
  const [isDecline, setIsDecline] = useState(false);
  const [customerDetails, setCustomerDetails] = useState(null);
  const [activeMemberDetails, setActiveMemberDetails] = useState(null);
  const [isFreeSubscription, setIsFreeSubscription] = useState(false);
  const { t } = useTranslation();
  const [isManualPay, setIsManualPay] = useState(false);
  const [searchParams] = useSearchParams()
  const [paymentMethodOptions, setPaymentMethodOptions] = useState([
    {
      label: t("Direct Debit"),
      value: "automatic",
    },
    {
      label: "Handmatig betalen",
      value: "manual",
    },
    // {
    //   label: t("Gratis abonnement"),
    //   value: null,
    // },
  ]);
  const isFetchingCities = useSelector(
    (state) => state.adminReducer.isFetchingCities
  );
  const activeEntity = useSelector((state) => state.adminReducer.activeEntity);
  const activeMember = useSelector((state) => state.adminReducer.activeMember);
  const customer = useSelector(
    (state) => state.adminReducer.memberDetails?.users
  );
  const isUpdatedSuccessfully = useSelector(
    (state) => state.adminReducer.memberDetails?.isUpdatedSuccessfully
  );
  const isApprovalDecline = useSelector(
    (state) => state.adminReducer.isApprovalDecline
  );
  const isApprovedApproval = useSelector(
    (state) => state.appReducer.isApprovedApproval
  );
  const memberPlans = useSelector((state) => state.adminReducer.memberPlans);
  const plan_list = memberPlans?.planList;

  const [errors, setErrors] = useState({});
  const [checkErrors, setcheckErrors] = useState({});
  const location = useLocation();
  const item = location.state;
  const [isToBeApproved, setIsToBeApproved] = useState(false);
  const [users, setUserData] = useState({
    contact_name: "",
    fname:"",
    lname:"",
    contact_email: "",
    country_code: "+31",
    contact_phone: "",
    contact_country: "",
    contact_city: "",
    contact_address: "",
    contact_pincode: "",
    subscription_plan_id: "",
    entity_id: "",
    subscription_id: "",
    customer_acc_name: "",
    customer_iban: "",
    paymentMode: "",
    age: "",
    dob: "",
    gender: "",
    isDigitalFormOnboarded:false
    //membership_date: new Date().toISOString(),
  });
  /*const [formData, setFormData] = useState({
    name: activeMemberDetails?.name ,
    emailAddress: activeMemberDetails?.emailAddress || '',
    phoneNumber: activeMemberDetails?.phoneNumber || '',
    countryCode: activeMemberDetails?.countryCode || '',
    subscription_plan_id: activeMemberDetails?.subscriptions?.[0]?.subscriptionId || ''
  });

  useEffect(() => {
    if (isActiveEdit && details) {
      setFormData({
        name: details.customer.contact_name || '',
        emailAddress: details.customer.contact_email || '',
        phoneNumber: details.customer.contact_phone || '',
        countryCode: details.customer.country_code || '',
        subscription_plan_id: details.subscriptions?.[0]?.subscription_plan_id || ''
      });
    }
  }, [isActiveEdit, details]); */

  // useEffect(() => {
  //   if (details) {
  //     const data = {};
  //     data.contact_name = details?.customer?.contact_name;
  //     data.contact_email = details?.customer?.contact_email;
  //     data.country_code = details?.customer?.country_code;
  //     data.contact_phone = details?.customer?.contact_phone;
  //     data.contact_country = details?.customer?.contact_country;
  //     data.contact_city = details?.customer?.contact_city;
  //     data.contact_address = details?.customer?.contact_address;
  //     data.contact_pincode = details?.customer?.contact_pincode;
  //     data.subscription_plan_id =
  //       details?.subscriptions?.[0]?.subscription_plan_id;
  //     data.entity_id = details?.subscriptions?.[0]?.entity_id;
  //     data.customer_acc_name = details?.customer?.customer_acc_name;
  //     data.customer_iban = details?.customer?.customer_iban;
  //     data.paymentMode = details?.customer?.paymentMode;
  //     data.subscription_id = details?.subscriptions?.[0]?.subscription_id;
  //     //data.membership_date = details?.subscriptions?.[0]?.member_since;

  //     setUserData(data);
  //     setIsFreeSubscription(data.subscription_plan_id === "free");
  //     setIsManualPay(data.paymentMode === "manual");
  //   } else {
  //     setUserData({
  //       contact_name: "",
  //       contact_email: "",
  //       country_code: "+31",
  //       contact_phone: "",
  //       contact_country: "",
  //       contact_city: "",
  //       contact_address: "",
  //       contact_pincode: "",
  //       subscription_plan_id: "",
  //       entity_id: "",
  //       subscription_id: "",
  //       customer_acc_name: "",
  //       customer_iban: "",
  //       paymentMode: "",
  //       //membership_date: new Date().toISOString(),
  //     });
  //     setIsFreeSubscription(false);
  //     setIsManualPay(false);
  //   }
  // }, [details]);

  useEffect(() => {
    setIsManualPay(users.paymentMode === "manual");
  }, [users.paymentMode]);

  useEffect(() => {
    if (users) {
      handleEmailAndPhoneValidation();
    }
  }, [users]);

  /*useEffect(() => {
    if (isApprovalDecline) {
      setTimeout(() => {
        window.location.href = `/mosque/${activeEntity?._id}/members/add`;
      }, 1000)
    }
  }, [isApprovalDecline]);*/

  const handleChangeUser = (keyName, keyValue) => {
    let update = { ...users };
    if (keyName === "contact_email") {
      keyValue = keyValue.toLowerCase();
    }
    if (keyName === "subscription_plan_id") {
      const selectedPlan = plan_list.filter(
        (item) => item._id === keyValue
      )?.[0];
      update.subscription_id = keyValue;
      setIsFreeSubscription(keyValue === "free");
      setIsManualPay(keyValue === "manual");
      if (keyValue === "free") {
        update.customer_acc_name = "";
        update.customer_iban = "";
        update.paymentMode = null;
        update.subscription_id = null;
      } else {
        update.paymentMode = "";
      }
    }
    if (keyName === "paymentMode") {
      if (keyValue === "manual") {
        update.customer_acc_name = "";
        update.customer_iban = "";
      }
      if (keyValue === null) {
        update.subscription_plan_id = "free";
        update.subscription_id = "free";
        // update.paymentMode = "notApplicable";
      }
      if (keyValue === "notApplicable") {
        update.paymentMode = null;
      }
      if (keyValue === "automatic" && (users?.subscription_id === null || "")) {
        update.subscription_plan_id = "";
        update.subscription_id = "";
      }
    }
    /*if (keyName === "membership_date") {
        update["membership_date"] = new Date(keyValue?.$d).toISOString();
    }*/
    if (
      keyName === "contact_country" &&
      keyValue !== update["contact_country"]
    ) {
      update["contact_city"] = "";
    }
    let newError = {};
    if(keyName === "fname" || keyName === "lname") {
      if(keyValue.includes(",")) {
        newError[keyName]= "Comma is not allowed";
        // keyValue = keyValue.replace(/,/g,"");
      } else {
        delete newError[keyName];
        keyValue = keyValue.replace(/,/g,"");
      }
    }
    if(keyName === "customer_acc_name" || keyName === "customer_iban") {
      if (keyValue === "Not Applicable") {
        update.customer_acc_name = null;
        update.customer_acc_name = null;
      }
    }
    update[keyName] = keyValue;
    if(keyName === "fname" || keyName === "lname"){
      update.contact_name = `${update.fname || ""}, ${update.lname || ""}`.trim();
    }
    setUserData(update);
    console.log("not allowed",newError)
    setcheckErrors(newError);
  };

  const optionsPlan = (paymentMode) => {
    let listValues = [];
    if (plan_list?.length) {
      plan_list.forEach((plan) => {
        if (plan.isFree) {
          // Check for a 'isFree' property in the plan object
          // Don't push the free plan to listValues
          return;
        }
        listValues.push({
          ...plan,
          label: `${plan.plan_name} - € ${plan.amount}`,
          value: plan._id,
        });
      });
    }
    // if (paymentMode === null) {
    //   listValues.unshift({
    //     label: t("Gratis abonnement"),
    //     value: "free", //
    //   });
    // }
    return listValues;
  };

  const handleSubmit = () => {
    const { isValid, error } = handleValidation();
    if (!isValid) {
      setErrors(error);
    } else {
      if(users?.paymentMode === "manual") {
        users.customer_acc_name = null;
        users.customer_iban = null;
      }
      // Form is valid, proceed with form submission
      SubmitMember();
    }
  };
  const calculateAge = () => {
    const dobDate = new Date(users.dob);
    const today = new Date();
    let cAge = today.getFullYear() - dobDate.getFullYear();
    const hasHadBirthday =
      today.getMonth() > dobDate.getMonth() ||
      (today.getMonth() === dobDate.getMonth() &&
        today.getDate() >= dobDate.getDate());

    if (!hasHadBirthday) {
      cAge--;
    }

    return cAge;
  };
  const SubmitMember = async () => {
    let update = { ...users };
    update.entity_id = activeEntity?._id;
    update.created_by_admin = true;
    update.age = calculateAge();
    if (update.subscription_plan_id === "free") {
      console.log(
        "Setting subscription_plan_id to before null : ",
        update.subscription_plan_id
      );
      update.subscription_plan_id = null;
      update.subscription_id = null;
      console.log(
        "Setting subscription_plan_id to after null : ",
        update.subscription_plan_id
      );
    }
    if (!update.contact_email) {
      update.contact_email = '';
    }
    if (!update.contact_address) {
      update.contact_address = null;
    }

    if (!update.customer_acc_name) {
      update.customer_acc_name = null;
    }

    if (!update.customer_iban) {
      update.customer_iban = null;
    }

    if (!update.contact_pincode) {
      update.contact_pincode = null;
    }

    if (!update.paymentMode) {
      update.paymentMode = null;
    }
    update.customer_iban = update.customer_iban?.toUpperCase();
    update.form_type='add-member';
    const trimmedDetails = {};
    // Trim each attribute and assign it to trimmedDetails object
    for (const key in update) {
      if (typeof update[key] === "string") {
        trimmedDetails[key] = update[key].trim();
      } else {
        trimmedDetails[key] = update[key];
      }
    }

    console.log("trimmed ", trimmedDetails);

    const res = await callApiV2({
      method: "post",
      endpoint: `onboarding/new-member-signup`,
      body: {
        users: trimmedDetails,
      },
      isErrorSuppressed: true,
    });
    if (res?.status === "Success") {
      setIsAddedNew(true);
      showNotification("success", t("New User Successfully Created."));
      setUserData({
        contact_name: "",
        contact_email: "",
        country_code: "+31",
        contact_phone: "",
        contact_country: "",
        contact_city: "",
        contact_address: "",
        contact_pincode: "",
        subscription_plan_id: "",
        //membership_date: "",
        entity_id: "",
        subscription_id: "",
        customer_acc_name: "",
        customer_iban: "",
        paymentMode: "",
        age: "",
        dob: "",
        gender: "",
      });
    } else {
      showNotification(
        "error",
        res?.data?.message || "Something went wrong..."
      );
    }
  };

  const handleValidation = () => {
    let isValid = true;
    let error = {};
    if (!users.fname) {
      isValid = false;
      error["fname"] = "This field is required";
    }
    if (!users.lname) {
      isValid = false;
      error["lname"] = "This field is required";
    }
    if(users?.fname?.includes(",")) {
      isValid = false;
      error["fname"] = "Comma is not allowed";
    }
    if(users?.lname?.includes(",")) {
      isValid = false;
      error["lname"] = "Comma is not allowed";
    }
    // if (!users.age) {
    //   isValid = false;
    //   error["age"] = "Dit veld is verplicht";
    // }
    // if (!users.dob) {
    //   isValid = false;
    //   error["dob"] = "Dit veld is verplicht";
    // }
    // if (!users.gender) {
    //   isValid = false;
    //   error["gender"] = "Dit veld is verplicht";
    // }
    if (users.contact_email && !isEmail(users.contact_email)) {
      isValid = false;
      error["contact_email"] = "Please enter a valid email address";
    }
    if (!users.contact_phone) {
      // && !phoneNumberRegex.test(users.contact_phone.replace(/[-()\s]/g, ""))
      isValid = false;
      error["contact_phone"] = "This field is required";
    }
    if (
      users.contact_phone &&
      (users.contact_phone.length<4 || users.contact_phone.length>13 )
    ) {
      isValid = false;
      error["contact_phone"] =
      t("Please enter a valid phone number");
    }
    if (!users.contact_country) {
      isValid = false;
      error["contact_country"] = "This field is required";
    }
    if (!users.contact_city) {
      isValid = false;
      error["contact_city"] = "This field is required";
    }
    if (!users.subscription_plan_id) {
      isValid = false;
      error["subscription_plan_id"] = "This field is required";
    }
    if (!users.paymentMode && users.paymentMode !== null) {
      isValid = false;
      error["paymentMode"] = "This field is required";
    }
    if (
      users.subscription_plan_id &&
      users.subscription_plan_id !== "free" &&
      !users.paymentMode
    ) {
      isValid = false;
      error["paymentMode"] =
        "Please select the payment method if you have chosen a membership";
    }
    if (
      users.subscription_plan_id !== "free" &&
      users.customer_acc_name &&
      users.customer_iban &&
      !users.paymentMode
    ) {
      isValid = false;
      error["paymentMode"] =
        "Please select payment method as automatic";
    }
    if (
      users.customer_acc_name &&
      !users.subscription_plan_id &&
      users.subscription_plan_id !== "free"
    ) {
      isValid = false;
      error["customer_acc_name"] = "Please select a membership";
    }
    if (
      users.customer_iban &&
      !users.subscription_plan_id &&
      users.subscription_plan_id !== "free"
    ) {
      isValid = false;
      error["customer_iban"] = "Please select a membership";
    }
    if (
      users.subscription_plan_id !== "free" &&
      users.paymentMode === "automatic" &&
      !users.customer_acc_name
    ) {
      isValid = false;
      error["customer_acc_name"] =
        "Please enter the account holder's name";
    }
    if (
      users.subscription_plan_id !== "free" &&
      users.paymentMode === "automatic" &&
      !users.customer_iban
    ) {
      isValid = false;
      error["customer_iban"] = "Please enter the user's IBAN";
    }
    if (
      users.customer_acc_name &&
      users.customer_iban &&
      users.subscription_plan_id === "free"
    ) {
      isValid = false;
      error["subscription_plan_id"] = "Please select a membership";
    }
    if (users?.paymentMode === "manual" && !users.subscription_plan_id) {
      isValid = false;
      error["paymentMode"] = "Please select a membership";
    }
    if(users.customer_iban){
      const val = validateIBAN(users.customer_iban);
      console.log("val of validate IBAN : ", val);
      if(val){
        isValid = false;
        error["customer_iban"] = val;
      }
    }
    return {
      isValid,
      error,
    };
  };

  const handleEmailAndPhoneValidation = () => {
    setErrors({});
    //let validate = handleValidation();
    /*if (!validate.isValid) {
      setErrors(validate.error);
      setIsNext(false);
    }
    else */ if (
      !!users?.contact_name?.trim() &&
      !!users?.contact_phone?.trim() &&
      !!users?.contact_country?.trim() &&
      !!users?.contact_city?.trim() &&
      !!users?.subscription_plan_id?.trim()
    ) {
      setIsNext(true);
    }
  };

  const handleButtonClick = () => {
    setIsAddedNew(false);
    window.location.href = `/user/add-members`;
  };

  const handleRedirection = () => {
    setIsAddedNew(false);
    window.location.href = `/user/members`;
  };

  const handleApproval = () => {
    dispatch({
      type: UPDATE_APPROVAL_STATUS,
      isApprovedApproval: false,
    });
    window.location.href = `/user/members`;
  };

  const handleClickDecline = () => {
    if (approvalId && activeEntity?._id) {
      dispatch(memberDecline(approvalId, activeEntity?._id))
      .then(() => {
        setIsDecline(false);
        setTimeout(() => {
          window.location.href = `/user/dashboard`;
        }, 1500);
      })
      .catch((error) => {
        toast.error(error)
        console.error("Error declining member:", error);
      });
    }
  };

  const handleClickApproval = () => {
    if(users.paymentMode === "automatic" && (!users.customer_acc_name || !users.customer_iban))
    {
      showNotification('error','Customer IBAN or Name missing')
      return;
    }
    if (memberSubId && approvalId) {
      dispatch(memberApprove(memberSubId, approvalId, users.user_id, users.isDigitalFormOnboarded))
      // .then(()=>{window.location.href = `/mosque/${activeEntity?._id}/info`})
      // .catch(err=> toast.error(err))
      
    }
  };
  useEffect(() => {
    const getUserData = async () => {
      try {
        console.log('item>>>>>>',item)
        const res = await fetch(
          `${apiURL}onboarding/mosque/${item?.entity_id}/member/${item?.ref_id}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );

        const json = await res.json();
        console.log('json>>>>>>>>>>>>>>>',json)
        details = json;
        if (details?.name) setIsToBeApproved(true);
        if (details) {
          const data = {};
          data.contact_name = details?.name;
          data.contact_email = details?.emailAddress||'';
          data.country_code = details?.countryCode || "+31";
          data.contact_phone = details?.phoneNumber;
          data.contact_country = details?.country;
          data.contact_city = details?.city;
          data.contact_address =  details?.address;
          data.contact_pincode = details?.postalCode;
          if (details?.emailAddress)
            data.subscription_plan_id =
              details?.subscriptions?.[0]?.subscriptionId ||
              "Gratis abonnement";
          data.entity_id = details?.subscriptions?.[0]?.entityId;
          data.customer_acc_name = details?.customerAccountName;
          data.customer_iban = details?.customerIBAN;
          if (details?.emailAddress)
            data.paymentMode = details?.paymentMode || "Gratis abonnement";
          data.subscription_id = details?.subscriptions?.[0]?.subscriptionId;
          data.age = details?.age;
          data.gender = details?.gender;
          data.dob = details?.dob;
          data.isDigitalFormOnboarded = details?.isDigitalFormOnboarded
          data.user_id = details._id;
          data.fname = details?.name?.split(',')[0]
          data.lname = details?.name?.split(',')[1]
          //data.membership_date = details?.subscriptions?.[0]?.member_since;

          setUserData(data);
          setIsFreeSubscription(data.subscription_plan_id === "free");
          setIsManualPay(data.paymentMode === "manual");
          console.log(data);
        } else {
          setUserData({
            contact_name: "",
            contact_email: "",
            country_code: "+31",
            contact_phone: "",
            contact_country: "",
            contact_city: "",
            contact_address: "",
            contact_pincode: "",
            subscription_plan_id: "",
            entity_id: "",
            subscription_id: "",
            customer_acc_name: "",
            customer_iban: "",
            paymentMode: "",
            age: "",
            gender: "",
            dob: "",
            //membership_date: new Date().toISOString(),
          });
          setIsFreeSubscription(false);
          setIsManualPay(false);
        }
      } catch (err) {
        console.log(err);
      }
    };
    getUserData();
  }, []);
  const getRenderButton = () => {
    if (details) {
      return (
        <Box display="flex" justifyContent="center">
          <Box>
            <Button
              type="outlineColor"
              text={t("Decline Member")}
              borderRadius="66px"
              minWidth="200px"
              mt="4"
              mx="auto"
              height="50px"
              onClick={() => setIsDecline(true)}
            />
          </Box>
          <Box ml="15px">
            <Button
              type="primary"
              text={t("Approve Member")}
              borderRadius="66px"
              minWidth="200px"
              mt="4"
              mx="auto"
              height="50px"
              onClick={() => handleClickApproval()}
            />
          </Box>
        </Box>
      );
    } else {
      return (
        <Button
          //type={!isNext ? "disabled" : "primary"}
          type="primary"
          text={t("Save Details")}
          borderRadius="66px"
          width="15%"
          mt="4"
          mx="auto"
          style={{
            fontSize: "18px",
            fontWeight: 800,
            fontFamily: "Raleway",
            minWidth: "188px",
          }}
          height="60px"
          onClick={handleSubmit}
        />
      );
    }
  };
  console.log("isTobeapproved -->", isToBeApproved);
  useEffect(() => {
    if(users?.subscription_plan_id === "free") {
      setPaymentMethodOptions([{label: t("Not Applicable"), value:null}])
    } else{
      setPaymentMethodOptions([
        {label: t("Automatic Payment"), value: "automatic"},
        {label: t("Manual Payment"), value: "manual"} 
      ])
    }
  },[users?.subscription_plan_id]);

  const validateIBAN = (iban) => {
    const errors = [];
    const ibanTrimmed = iban.trim().toUpperCase();
    const isNetherlands = ibanTrimmed.startsWith("NL");
    const isBelgium = ibanTrimmed.startsWith("BE");
    const isGermany = ibanTrimmed.startsWith("DE");

    // Check starts with "NL, BE, DE"
    if (!isNetherlands && !isBelgium && !isGermany) {
      errors.push("IBAN only valid for Netherlands, Belgium, Germany");
    }
    if(isNetherlands) {
      // Check overall length for NL
      if (ibanTrimmed.length !== 18) {
        errors.push("IBAN must be exactly 18 characters long for Netherlands");
      } else {
        // Next 2 characters should be numbers
        const digitsAfterNL = ibanTrimmed.substring(2, 4);
        if (!/^\d{2}$/.test(digitsAfterNL)) {
          errors.push("Invalid IBAN");
        }
        // Next 4 characters should be alphabets
        const bankCodeNL = ibanTrimmed.substring(4, 8);
        if (!/^[A-Za-z]{4}$/.test(bankCodeNL)) {
          errors.push("Invalid IBAN");
        }
        // Next 10 characters should be numbers
        const accountNumberNL = ibanTrimmed.substring(8);
        if (!/^\d{10}$/.test(accountNumberNL)) {
          errors.push("Invalid IBAN");
        }
      }
    }
    if(isBelgium) {
      if (ibanTrimmed.length !== 16) {
        errors.push("IBAN must be exactly 16 characters long for Belgium");
      } else {
        const digitsAfterBE = ibanTrimmed.substring(2, 4);
        if (!/^\d{2}$/.test(digitsAfterBE)) {
          errors.push("Invalid IBAN");
        }
        const accountNumberBE = ibanTrimmed.substring(4);
        if (!/^\d{12}$/.test(accountNumberBE)) {
          errors.push("Invalid IBAN");
        }
      }
    }
    if(isGermany) {
      if (ibanTrimmed.length !== 22) {
        errors.push("IBAN must be exactly 22 characters long for Germany");
      } else {
        const digitsAfterDE = ibanTrimmed.substring(2);
        if (!/^\d{20}$/.test(digitsAfterDE)) {
          errors.push("Invalid IBAN");
        }
      }
      
      // const bankCodeDE = ibanTrimmed.substring(4, 12);
      // if (!/^\d{8}$/.test(bankCodeDE)) {
      //   errors.push("Characters 5 to 8 must be numbers.");
      // }
      // const accountNumberDE = ibanTrimmed.substring(12);
      // if (!/^\d{10}$/.test(accountNumberDE)) {
      //   errors.push("Characters 9 to 22 must be numbers.");
      // }
    }
  
    return errors.length > 0 ? errors : null;
  };
  
  function parseDDMMYYYYToDate(dateStr) {
  const [day, month, year] = dateStr.split("-");
  return new Date(`${year}-${month}-${day}`);
}

  

  return (
    <div className="add_form form_width">
      <div className="mosque-form">
        <h2 className="headingTwo">{t("Personal Information")}</h2>
        <div className="row">
          <div className="col-lg-6 input-width add-input-field-margin">
            <label mb="8px" isMandatory>
              {t("First Name")} <span style={{ color: "#FE1717" }}>*</span>
            </label>
            <input
              value={users?.fname}
              onChange={(e) => handleChangeUser("fname", e.target.value)}
              type="text"
              placeholder={t("Enter First Name")}
              className="input-box"
              disabled={isToBeApproved}
            />
            {errors.fname && (
              <ErrorMessage>{t(errors.fname)}</ErrorMessage>
            )}
            {checkErrors.fname && (
              <ErrorMessage>{t(checkErrors.fname)}</ErrorMessage>
            )}
          </div>
          <div className="col-lg-6 input-width add-input-field-margin">
            <label mb="8px" isMandatory>
              {t("Last Name")} <span style={{ color: "#FE1717" }}>*</span>
            </label>
            <input
              value={users?.lname}
              onChange={(e) => handleChangeUser("lname", e.target.value)}
              type="text"
              placeholder={t("Enter Last Name")}
              className="input-box"
              disabled={isToBeApproved}
            />
            {errors.lname && (
              <ErrorMessage>{t(errors.lname)}</ErrorMessage>
            )}
            {checkErrors.lname && (
              <ErrorMessage>{t(checkErrors.lname)}</ErrorMessage>
            )}
          </div>
          <div className="col-lg-6 pt-2 input-width add-input-field-margin">
            <label mb="8px">
              {t("Email Address")} 
            </label>
            <input
              onBlur={() => handleEmailAndPhoneValidation()}
              value={users?.contact_email}
              onChange={(e) =>
                handleChangeUser("contact_email", e.target.value)
              }
              type="text"
              placeholder={t("Enter Your Email Address")}
              className="input-box"
              disabled={isToBeApproved}
            />
            {errors.contact_email && (
              <ErrorMessage>{t(errors.contact_email)}</ErrorMessage>
            )}
          </div>
          <div className="col-lg-6 pt-2 input-width add-input-field-margin">
            <label mb="8px" isMandatory>
              {t("Contact Number")} <span style={{ color: "#FE1717" }}>*</span>
            </label>
            <Input
              onBlur={() => handleEmailAndPhoneValidation()}
              value={users?.contact_phone}
              countryCodes={true}
              countryCodeValue={users?.country_code}
              setCountryCode={(e) => handleChangeUser("country_code", e)}
              isDisabled={isToBeApproved}
              onChange={(e) =>
                handleChangeUser("contact_phone", e.target.value)
              }
              border={users?.contact_phone?.length ? "1px solid #606734" : null}
              placeholder="785-785-464"
              className="input-box"
              type="number"
              pattern="[0-9]"
              height="52px"
              overflow="unset"
            />
            {errors.contact_phone && (
              <ErrorMessage>{t(errors.contact_phone)}</ErrorMessage>
            )}
          </div>

          <div className="col-lg-6 pt-2 input-width add-input-field-margin">
          <>
                <label mb="8px" isMandatory>
                  {t("User's Country")}{" "}
                  <span style={{ color: "#FE1717" }}>*</span>
                </label>
                <Select
                  size="middle"
                  // allowSearch
                  // variant="outlinedGreen"
                  // defaultText={users?.contact_country || t("Select Country")}
                  // color="#1a1a1aad"
                  // fontSize="18px"
                  // fontWeight="500"
                  // width="100%"
                  // height="54px"
                  // Icon="none"
                  className="dropdown-style"
                  style={{
                    fontFamily: "Raleway",
                    fontWeight: 400,
                    fontSize: "18px",
                    color: "#1A1A1A",
                    width: "100%",
                    height: "auto"
                  }}
                  defaultValue={users?.contact_country || t("Select Country")}
                  value={users?.contact_country || t("Select Country") }
                  onChange={(value, option) => {
                    handleChangeUser("contact_country", value);
                    dispatch({
                      type: STORE_CITIES,
                      cities: [],
                    });
                  }}
                  options={customCountries}
                  disabled={isToBeApproved}
                />
                {errors.contact_country && (
                  <ErrorMessage>{t(errors.contact_country)}</ErrorMessage>
                )}
              </>
          </div>

          <div className="col-lg-6 pt-2 input-width add-input-field-margin">
            <label mb="8px">{t("Postcode")}</label>
            <input
              value={users?.contact_pincode}
              onChange={(e) =>
                handleChangeUser("contact_pincode", e.target.value)
              }
              type="text"
              placeholder={t("Enter Postal Code")}
              className="input-box"
              disabled={isToBeApproved}
            />
          </div>
          <div className="col-lg-6 pt-2 input-width add-input-field-margin">
            {isFetchingCities ? (
              <div
                className="d-flex justify-content-center align-items-center"
                style={{ height: "100%" }}
              >
                <Spinner />
              </div>
            ) : (
              <>
                <label mb="8px" isMandatory>
                  {t("User's City")}{" "}
                  <span style={{ color: "#FE1717" }}>*</span>
                </label>
                {/* <Dropdown
              allowSearch
              variant="outlinedGreen"
              defaultText={users?.contact_city || t("Select City")}
              color="#1A1A1A"
              fontSize="18px"
              fontWeight="400"
              width="100%"
              height="54px"
              Icon="none"
              noResultIcon=""
              selectedValue={users?.contact_city}
              onOptionClick={(item) =>
                handleChangeUser("contact_city", item?.value)
              }
              options={cities}
              disabled={isToBeApproved}
            /> */}
                <CitySelectUser
                  defaultText={t("Select City")}
                  handleChangeUser={handleChangeUser}
                  users={users}
                  cities={cities}
                />
                {errors.contact_city && (
                  <ErrorMessage>{t(errors.contact_city)}</ErrorMessage>
                )}
              </>
            )}
          </div>
          <div className="col-lg-6 pt-2 input-width add-input-field-margin">
            <label mb="8px">{t("User Address")}</label>
            <input
              value={users?.contact_address}
              onChange={(e) =>
                handleChangeUser("contact_address", e.target.value)
              }
              type="text"
              placeholder={t("Enter User's Address")}
              className="input-box"
              disabled={isToBeApproved}
            />
          </div>

          {/* <div className="col-lg-6 pt-2 input-width add-input-field-margin">
            <label mb="8px">{t('Age')} <span style={{ color: "#FE1717" }}>*</span></label>
            <input
              type="number"
              value={users?.age || ''}
              onChange={(e) => handleChangeUser("age", e.target.value)}
              placeholder={t("Enter age")}
              className="input-box"
              disabled={isToBeApproved}
              min="0" 
              max="120" 
            />
            {errors.age && (
              <ErrorMessage>{t(errors.age)}</ErrorMessage>
            )}
          </div> */}
          <div className="col-lg-6 pt-2 input-width add-input-field-margin">
            <label mb="8px">
              {t("Date of Birth")}
            </label>
            <input
              type="date"
              value={users.isDigitalFormOnboarded && users.dob
      ? parseDDMMYYYYToDate(users.dob).toISOString().split("T")[0]
      : users?.dob || ''}
              onChange={(e) => handleChangeUser("dob", e.target.value)}
              className="input-box calendar"
              disabled={isToBeApproved}
              max={
                new Date(new Date().setFullYear(new Date().getFullYear() - 18))
                  .toISOString()
                  .split("T")[0]
              }
              min={
                new Date(new Date().setFullYear(new Date().getFullYear() - 100))
                  .toISOString()
                  .split("T")[0]
              }
            />
            {errors.dob && <ErrorMessage>{t(errors.dob)}</ErrorMessage>}
          </div>

          <div className="col-lg-6 pt-2 input-width add-input-field-margin">
            <label mb="28px">
              {t("Gender")}
            </label>
            <div
              mt="20px"
              style={{
                marginTop: "10px",
                display: "flex",
                alignItems: "center",
                gap: "20px",
              }}
              className="radio-group"
            >
              <label
                style={{ display: "flex", alignItems: "center", gap: "10px" }}
              >
                <input
                  type="radio"
                  name="gender"
                  value="male"
                  checked={users?.gender === "male"}
                  onChange={(e) => handleChangeUser("gender", e.target.value)}
                  disabled={isToBeApproved}
                />
                {t("Male")}
              </label>
              <label
                style={{ display: "flex", alignItems: "center", gap: "10px" }}
              >
                <input
                  type="radio"
                  name="gender"
                  value="female"
                  checked={users?.gender === "female"}
                  onChange={(e) => handleChangeUser("gender", e.target.value)}
                  disabled={isToBeApproved}
                />
                {t("Female")}
              </label>
            </div>
            {errors.gender && <ErrorMessage>{t(errors.gender)}</ErrorMessage>}
          </div>
        </div>

        <h2 className="headingTwo" style={{ marginTop: "20px" }}>
          {t("Payment Information")}
        </h2>

        <div
          className="row"
          style={{ pointerEvents: isToBeApproved ? "none" : "" }}
        >
          <div className="col-lg-6 pt-2 input-width add-input-field-margin">
            <label mb="8px">
              {t("Membership")} <span style={{ color: "#FE1717" }}>*</span>
            </label>
            <Select
              size="middle"
              style={{
                fontFamily: "Raleway",
                fontWeight: 400,
                fontSize: "18px",
                color: "#1A1A1A",
                width: "100%",
                height: "auto"
              }}
              // disabled={users?.paymentMode === null}
              value={users?.subscription_plan_id || t("Select Plan")}
              onChange={(value) =>
                handleChangeUser("subscription_plan_id", value)
              }
              options={[
                {value: "free", label: t("Free Subscription")},
                ...optionsPlan(users?.paymentMode),]}
            />
              {errors.subscription_plan_id && (
                <ErrorMessage>{t(errors.subscription_plan_id)}</ErrorMessage>
              )}
          </div>

          <div className="col-lg-6 pt-2 input-width add-input-field-margin">
            <label mb="8px">
              {t("Payment Method")} <span style={{ color: "#FE1717" }}>*</span>
            </label>
            <Select
              size={"middle"}
              className="dropdown-style"
              value={
                users?.paymentMode ||
                (users?.paymentMode === null
                  ? t("Not Applicable")
                  : t("Select Type"))
              }
              defaultValue={t("Select type")}
              onChange={(value) => {
                handleChangeUser("paymentMode", value);
              }}
              style={{ width: "100%", height: "auto" }}
              options={paymentMethodOptions}
            />
            {errors.paymentMode && (
              <ErrorMessage>{t(errors.paymentMode)}</ErrorMessage>
            )}
          </div>
          <div className="col-lg-6 pt-2 input-width add-input-field-margin">
            <label mb="8px">
              {t("Account Holder Name")}{" "}
              {users.paymentMode === "automatic" && (
                <span style={{ color: "#FE1717" }}>*</span>
              )}
            </label>
            <input
              value={users?.customer_acc_name}
              onChange={(e) =>
                handleChangeUser("customer_acc_name", e.target.value)
              }
              type="text"
              placeholder={t("Enter Account Holder Name")}
              className="input-box"
              disabled={users?.subscription_id === null || users?.subscription_id === "free" || users?.paymentMode === "manual"}
            />
            {errors.customer_acc_name && (
              <ErrorMessage>{t(errors.customer_acc_name)}</ErrorMessage>
            )}
          </div>
          <div className="col-lg-6 pt-2 input-width add-input-field-margin">
            <label mb="8px">
              {t("User's IBAN")}{" "}
              {users.paymentMode === "automatic" && (
                <span style={{ color: "#FE1717" }}>*</span>
              )}
            </label>
            <input
              value={users?.customer_iban}
              onChange={(e) =>
                handleChangeUser(
                  "customer_iban",
                  e.target.value?.replace(/[^0-9a-zA-Z]/g, "")
                )
              }
              type="text"
              placeholder={t("Enter User's IBAN")}
              className="input-box"
              disabled={users?.subscription_id === null || users?.subscription_id === "free" || users?.paymentMode === "manual"}
            />
            {errors.customer_iban && (
              <ErrorMessage>{t(errors.customer_iban)}</ErrorMessage>
            )}
          </div>
          {/*<div className="col-lg-6 pt-2 mb-4 input-width">
            <label mb="8px" isMandatory>
            Lidmaatschapsdatum
            </label>
            <DatePickerBox>
              <DatePicker
                defaultValue={dayjs()}
                value={dayjs(users?.membership_date, "YYYY-MM-DD")}
                onChange={(value) => handleChangeUser("membership_date", value)}
              />
            </DatePickerBox>
            {errors.membership_date && (
              <ErrorMessage>{errors.membership_date}</ErrorMessage>
            )}
            </div>*/}
        </div>
        {getRenderButton()}
        <br />
      </div>
      <DefaultModal
        show={isAddedNew}
        onHide={() => setIsAddedNew(false)}
        className="add-mosque-modal"
        centered={true}
        showHeader={false}
        size=""
        showFooter={false}
      >
        <div>
          <Icon
            iconName="modalClose"
            iconSize="xs"
            style={{ marginLeft: "auto" }}
            onClick={() => handleRedirection()}
          />
          <div className="text-center add-mosque-modal-content">
            <Icon
              iconName="congratulations"
              style={{ justifyContent: "center" }}
            />
            <div>{t("Congratulations")}</div>
            <div style={{ textAlign: "center" }}>
              {t("We have added the new user's details.")}
            </div>
            <Box
              display="flex"
              justifyContent="center"
              onClick={() => handleButtonClick()}
            >
              <Button width="40px">{t("Add New Member")}</Button>
            </Box>
          </div>
        </div>
      </DefaultModal>

      <DefaultModal
        show={isApprovedApproval}
        onHide={() => handleApproval()}
        className="add-mosque-modal"
        centered={true}
        showHeader={false}
        size=""
        showFooter={false}
      >
        <div>
          <Icon
            iconName="modalClose"
            iconSize="xs"
            style={{ marginLeft: "auto" }}
            onClick={() => handleApproval()}
          />
          <div className="text-center">
            <Icon
              iconName="congratulations"
              style={{ justifyContent: "center" }}
            />
            <Label
              justifyContent="center"
              fontSize="20px"
              fontWeight={700}
              my="20px"
            >
              {t("Congratulations!")}
            </Label>
            <Label
              variant="text3"
              my="20px"
              color="#7E7E7E"
              justifyContent="center"
            >
              {t("We have added the new member.")}
            </Label>
            <Button
                minWidth="200px !important"
                width="200px !important"
                height="45px !important"
                justifyContent="center"
                onClick={() => handleApproval()}
                margin="0 auto !important"
              >
                {t("View Member")}
              </Button>
          </div>
        </div>
      </DefaultModal>

      <DefaultModal
        show={isDecline}
        onHide={() => setIsDecline(false)}
        className="add-mosque-modal"
        centered={true}
        showHeader={false}
        size=""
        showFooter={false}
      >
        <div>
          <Icon
            iconName="modalClose"
            iconSize="xs"
            style={{ marginLeft: "auto" }}
            onClick={() => setIsDecline(false)}
          />
          <div className="text-center">
            <img src="https://ik.imagekit.io/rzlzf40okya/elixir/diseble.svg" />
            <Label
              justifyContent="center"
              fontSize="20px"
              fontWeight={700}
              my="20px"
            >
              {t("Decline Member")}
            </Label>
            <Label variant="text3" my="20px" color="#7E7E7E">
              {t(
                "You will permanently loose this member’s details and other information."
              )}
            </Label>
            <Box className="test" display="flex" justifyContent="center">
              <Button
                className="test"
                type="outlineColor"
                minWidth="200px !important"
                width="200px !important"
                height="45px !important"
                mr="20px !important"
                onClick={() => setIsDecline(false)}
              >
                {t("Cancel")}
              </Button>
              <Button
                minWidth="200px !important"
                width="200px !important"
                height="45px !important"
                mr="20px !important"
                onClick={() => handleClickDecline()}
              >
                {t("Decline Member")}
              </Button>
            </Box>
          </div>
        </div>
      </DefaultModal>
    </div>
  );
};

export default AddForm;
